import React, { useState, useContext, useEffect } from 'react';
import './Home.css';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import AuthContext from "../../context/Services/Auth";

import Sidebar from '../../Components/Sidebar/Sidebar';
import PageHeader from '../../Components/PageHeader/PageHeader';

import Dashboard from '../../Containers/Dashboard/Dashboard';
import Clients from '../../Containers/Clients/Clients';
import Staff from '../../Containers/Staff/Staff';
import Stock from '../../Containers/Stock/Stock';
import AddStockPage from '../../Containers/AddStockPage/AddStockPage';
import AddStaff from '../../Containers/AddStaff/AddStaff';
import Settings from '../../Containers/Settings/Settings';
import Shipments from '../../Containers/Shipments/Shipments';
import Costs from '../../Containers/Costs/Costs';
import Suppliers from '../../Containers/Suppliers/Suppliers';
import ProductCatalogue from '../../Containers/ProductCatalogue/ProductCatalogue';


const tabs = [
	{
		access: ["admin", "employee"],
		value: Dashboard,
		path: '/*'
	},
	{
		access: ["admin"],
		value: Settings,
		path: '/settings/*'
	},
	{
		access: ["admin"],
		value: Staff,
		path: '/staff'
	},
	{
		access: ["admin"],
		value: AddStaff,
		path: '/add_staff'
	},
	{
		access: ["admin"],
		value: AddStaff,
		path: '/staff/:id'
	},

	{
		access: ["admin", "employee"],
		value: Stock,
		path: '/stock'
	},
	{
		access: ["admin", "employee"],
		value: AddStockPage,
		path: '/add_stock'
	},
	{
		access: ["admin", "employee"],
		value: AddStockPage,
		path: '/stock/:id'
	},
	{
		access: ["admin", "employee", "commercial"],
		value: Shipments,
		path: '/shipments',
	},
	{
		access: ["admin", "employee", "commercial"],
		value: ProductCatalogue,
		path: '/catalogue',
	},
	{
		access: ["admin", "employee"],
		value: Costs,
		path: '/costs'
	},
	{
		access: ["admin", "employee"],
		value: Suppliers,
		path: '/suppliers'
	},
	{
		access: ["admin"],
		value: Clients,
		path: '/clients'
	},
];

const Home = () => {
	const { userData } = useContext(AuthContext);
	const [showSideBar, setShowSideBar] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	// Redirect commercial users to shipments page after login
	useEffect(() => {
		if (userData?.role === "commercial" && location.pathname === "/") {
			navigate("/shipments", { replace: true });
		}
	}, [userData, location.pathname, navigate]);

	return (
		<main className="home_main flex">
			<div className="view_conatiner">
				<PageHeader showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
				<Sidebar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

				<Routes>
					{
						tabs.map((elem, index) => (
							elem.access.includes(userData?.role) &&
							<Route key={index} path={elem.path} element={<elem.value />} />
						))
					}
				</Routes>
			</div>
		</main>
	)
}

export default Home